export enum SpecialEventType {
  EXHIBITION = 'EXHIBITION',
  THEME = 'THEME',
  FLEAMARKET = 'FLEAMARKET',
  TIP_SHOPPING = 'TIP_SHOPPING',
  RANKING_SHOPPING = 'RANKING_SHOPPING',
}

export enum ExposureType {
  EXHIBITION = 'EXHIBITION',
  CONTENTS = 'CONTENTS',
}

export enum ExposureImageType {
  BANNER = 'BANNER',
  PRODUCT = 'PRODUCT',
}

export const getSpecialEventTypeByPath = (pathname: string): any => {
  const splitPath: string[] = pathname.split('/')

  return Object.keys(SpecialEventType).find(specialEvent => splitPath.includes(specialEvent.toLowerCase()))
}

export const getSpecialEventType = (queryParams: any): any => {
  const specialEventType = queryParams.eventType || null
  if (specialEventType) {
    return Object.keys(SpecialEventType).find(
      specialEvent => specialEvent.toLowerCase() === specialEventType.toLowerCase(),
    )
  }
  return specialEventType
}

export const getSpecialEventTitle = (eventType: SpecialEventType): string => {
  switch (eventType) {
    case SpecialEventType.EXHIBITION:
      return 'EVENT'
    case SpecialEventType.THEME:
      return '테마기획'
    case SpecialEventType.FLEAMARKET:
      return '플리마켓'
    case SpecialEventType.TIP_SHOPPING:
      return '쇼핑꿀팁'
    case SpecialEventType.RANKING_SHOPPING:
      return '랭킹쇼핑'
    default:
      return eventType
  }
}
